import {ReportModel} from "@fedeltapointofsale/data-client";
import {BestWorstSellersReportData} from "./best-worst-sellers-report.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class BestWorstSellersReportModel extends ReportModel<BestWorstSellersReportData> {
    constructor(injector: Injector) {
        super(injector, BestWorstSellersReportData)
    }
}
